import { render, staticRenderFns } from "./addNewIndex.vue?vue&type=template&id=62d49f3e&scoped=true"
import script from "./addNewIndex.vue?vue&type=script&lang=js"
export * from "./addNewIndex.vue?vue&type=script&lang=js"
import style0 from "./addNewIndex.vue?vue&type=style&index=0&id=62d49f3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d49f3e",
  null
  
)

export default component.exports